import { render, staticRenderFns } from "./packet-base-course.vue?vue&type=template&id=d77378e0&"
import script from "./packet-base-course.vue?vue&type=script&lang=ts&"
export * from "./packet-base-course.vue?vue&type=script&lang=ts&"
import style0 from "./packet-base-course.vue?vue&type=style&index=0&id=d77378e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports